import { NOTIFICATION_SHOW } from './actionTypes';

export const notificationShow = notification => ({
    type: NOTIFICATION_SHOW,
    notification
});
